import React, { Component } from 'react'
import { connect } from 'react-redux'
import Swal from 'sweetalert2'
import { callme } from '../../requesters/clients'
import { configuration } from '../../configuration'

import './styles.css'

class Header extends Component {

  constructor(props) {
    super(props)
  }

  handleCallMe = () => {
    Swal.fire({
      title: '¿Necesitas ayuda?',
      html: '<span>Te asesoramos en la reparacion de tu ' + configuration().coche + '</span>',
      input: 'text',
      inputPlaceholder: 'Tu teléfono',
      imageUrl: configuration().headerLogo,
      confirmButtonText: 'Recibir llamada',
      confirmButtonColor: configuration().clientColor,
      confirmButtonClass: 'modal-button',
      width: '350px',
      inputValidator: (value) => {
        return !value && '¡Escribe tu teléfono!'
      }
    }).then((result) => {
      if (result.value) {
        const callmeEmail = this.props.callmeEmail ? this.props.callmeEmail : this.props.defaultAdvisorEmail
        callme({ advisor: callmeEmail, phone: result.value })
          .then((result) => {
            if (result.data.status === 'OK') {
              const url = configuration().redirects.graciasLlamada;
              window.location.assign(url);
              // Swal.fire({
              //     type: 'success',
              //     title: 'Hemos recibido su teléfono',
              //     html: '<span>En breve nos pondremos en contacto contigo</span>',
              //     confirmButtonColor: configuration().clientColor,
              //     confirmButtonClass: 'modal-button',
              // })
            } else {
              Swal.fire({
                type: 'error',
                title: 'Algo salio mal',
                html: '<span>No hemos podido recibir su número de teléfono. Intentelo mas tarde.</span>',
                confirmButtonColor: configuration().clientColor,
                confirmButtonClass: 'modal-button',
              })
            }

          }).catch((err) => {
            Swal.fire({
              type: 'error',
              title: 'Algo salio mal',
              html: '<span>No hemos podido recibir su número de teléfono. Intentelo mas tarde.</span>',
              confirmButtonColor: configuration().clientColor,
              confirmButtonClass: 'modal-button',
            })
          })

      }
    })
  }

  render() {
    let headerLogo
    if (configuration().brandName && configuration().brandName.toLowerCase() === 'mazda') {
      headerLogo = <img style={{ marginLeft: "15%" }} src={configuration().headerLogo} width={configuration().headerLogoWith} height={configuration().headerLogoHeight} />
    } else if (configuration().headerLogo.includes(',')){
      let headersLogo=[]
      configuration().headerLogo.split(',').forEach(element => {
          headersLogo.push(<img src={element} width={configuration().headerLogoWith} height={configuration().headerLogoHeight}/>)
      })
      headerLogo = (<div>{headersLogo}</div>)
    } else {
      headerLogo = <img src={configuration().headerLogo} width={configuration().headerLogoWith} height={configuration().headerLogoHeight} />
    }
    return (
      <nav className="navbar navbar-light navbar-fixed-top header"
        style={{ backgroundColor: configuration().clientSecondaryColor }}>
        {headerLogo}
        {this.props.defaultAdvisorEmail || this.props.callmeEmail
          ? <span className="navbar-toggler" onClick={this.handleCallMe}>¿Te llamamos?</span>
          : <span></span>}
      </nav>
    )
  }



}

const mapStateToProps = state => {
  return {
    defaultAdvisorEmail: state.checkout.workshop.defaultAdvisorEmail,
    callmeEmail: state.checkout.workshop.callmeEmail
  }
}

const bindActions = dispatch => ({

});

export default connect(mapStateToProps, bindActions)(Header);



// WEBPACK FOOTER //
// ./src/components/header/index.js